import React from 'react';

class UnknownErrorModal extends React.Component{
    constructor(){
        super()
        this.state = {
            primaryBtnFocused: false,
            primaryBtnHovered: false,
            secondaryBtnHovered: false,
            secondaryBtnFocused: false
        }
    }
    toggleHoverPrimaryButton = () => {
        this.setState(prevState => ({
            primaryBtnHovered: !prevState.primaryBtnHovered
        }))
    }
    toggleFocusPrimaryButton = () => {
        this.setState(prevState => ({
            primaryBtnFocused: !prevState.primaryBtnFocused
        }))
    }
    toggleHoverSecondaryButton = () => {
        this.setState(prevState => ({
            secondaryBtnHovered: !prevState.secondaryBtnHovered
        }))
    }
    toggleFocusSecondaryButton = () => {
        this.setState(prevState => ({
            secondaryBtnFocused: !prevState.secondaryBtnFocused
        }))
    }
    render(){
        return(
            <div className="modal-body">
                <div className="container-fluid">
                    {global.wordpressError?
                        <div dangerouslySetInnerHTML = {{__html: global.modalContent1}}></div>:
                        <div dangerouslySetInnerHTML = {{__html: global.modalContent2}}></div>
                    }
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <a href={global.cartUrl}>
                                <button type="button" className={`modal-add-to-cart-btn
                                ${this.state.primaryBtnHovered?"primary-btn-hovered":""}
                                ${this.state.primaryBtnFocused?"blue-btn-focused":""}`}
                                onMouseEnter={() => this.toggleHoverPrimaryButton()}
                                onMouseLeave={() => this.toggleHoverPrimaryButton()}
                                onFocus={() => this.toggleFocusPrimaryButton()}
                                onBlur={() => this.toggleFocusPrimaryButton()}>VIEW CART</button>
                            </a>
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <button type="button" className={`modal-keep-shopping-btn
                            ${this.state.secondaryBtnHovered? "secondary-btn-hovered":""}
                            ${this.state.secondaryBtnFocused? "blue-btn-focused":""}`}
                            onClick={this.props.closeModalHandler}
                            onMouseEnter={() => this.toggleHoverSecondaryButton()}
                            onMouseLeave={() => this.toggleHoverSecondaryButton()}
                            onFocus={() => this.toggleFocusSecondaryButton()}
                            onBlur={() => this.toggleFocusSecondaryButton()}>KEEP SHOPPING</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default UnknownErrorModal